import { memo } from 'react';
import { Card, VStack } from '@direct-frontend/components';
import { type OpenApiSchemaAlert } from '#shared/api/schema';
import { DashboardAlertsList } from '../DashboardAlertsList';
import { DashboardAlertsPlaceholder } from '../DashboardAlertsPlaceholder';
import styles from './DashboardAlertsWindow.module.css';

type DashboardAlertsWindowContentProps = {
    alerts?: readonly OpenApiSchemaAlert[];
    isEmpty: boolean;
    onAction: VoidFunction;
    onClose: VoidFunction;
};

const DashboardAlertsWindowContent = ({ alerts, isEmpty, onAction, onClose }: DashboardAlertsWindowContentProps) => (
    <Card color="white" borderRadius="14" className={styles.wrapperCard}>
        <VStack maxHeight="524px">
            {isEmpty ? (
                <DashboardAlertsPlaceholder />
            ) : (
                <DashboardAlertsList alerts={alerts} onAction={onAction} onClose={onClose} />
            )}
        </VStack>
    </Card>
);

type DashboardAlertsWindowProps = {
    alerts?: readonly OpenApiSchemaAlert[];
    isEmpty: boolean;
    onAction: VoidFunction;
    onClose: VoidFunction;
};

export const DashboardAlertsWindow = memo(function DashboardAlertsWindow({
    alerts,
    isEmpty,
    onAction,
    onClose,
}: DashboardAlertsWindowProps) {
    return (
        <DashboardAlertsWindowContent
            alerts={alerts}
            isEmpty={alerts === undefined ? isEmpty : alerts.length === 0}
            onAction={onAction}
            onClose={onClose}
        />
    );
});
